export default __webpack_public_path__ + "static/media/stock.c3b3b03a.png";